module.exports = __webpack_public_path__ + "img/03.e791da9b.png";